module.exports = __webpack_public_path__ + "img/placard_04.0e4d3879.png";